var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnConfigurationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.25C22.4142 11.25 22.75 11.5858 22.75 12V25.5C22.75 25.9142 22.4142 26.25 22 26.25C21.5858 26.25 21.25 25.9142 21.25 25.5V12C21.25 11.5858 21.5858 11.25 22 11.25ZM22 28.75C22.4142 28.75 22.75 29.0858 22.75 29.5V32C22.75 32.4142 22.4142 32.75 22 32.75C21.5858 32.75 21.25 32.4142 21.25 32V29.5C21.25 29.0858 21.5858 28.75 22 28.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.25C15.4142 11.25 15.75 11.5858 15.75 12V15.5C15.75 15.9142 15.4142 16.25 15 16.25C14.5858 16.25 14.25 15.9142 14.25 15.5L14.25 12C14.25 11.5858 14.5858 11.25 15 11.25ZM15 18.75C15.4142 18.75 15.75 19.0858 15.75 19.5L15.75 32C15.75 32.4142 15.4142 32.75 15 32.75C14.5858 32.75 14.25 32.4142 14.25 32L14.25 19.5C14.25 19.0858 14.5858 18.75 15 18.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 11.25C29.4142 11.25 29.75 11.5858 29.75 12V18.5C29.75 18.9142 29.4142 19.25 29 19.25C28.5858 19.25 28.25 18.9142 28.25 18.5V12C28.25 11.5858 28.5858 11.25 29 11.25ZM29 21.75C29.4142 21.75 29.75 22.0858 29.75 22.5V32C29.75 32.4142 29.4142 32.75 29 32.75C28.5858 32.75 28.25 32.4142 28.25 32V22.5C28.25 22.0858 28.5858 21.75 29 21.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 16.5H13.5C12.9477 16.5 12.5 16.9477 12.5 17.5C12.5 18.0523 12.9477 18.5 13.5 18.5H16.5C17.0523 18.5 17.5 18.0523 17.5 17.5C17.5 16.9477 17.0523 16.5 16.5 16.5ZM13.5 15C12.1193 15 11 16.1193 11 17.5C11 18.8807 12.1193 20 13.5 20H16.5C17.8807 20 19 18.8807 19 17.5C19 16.1193 17.8807 15 16.5 15H13.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 26.5H20.5C19.9477 26.5 19.5 26.9477 19.5 27.5C19.5 28.0523 19.9477 28.5 20.5 28.5H23.5C24.0523 28.5 24.5 28.0523 24.5 27.5C24.5 26.9477 24.0523 26.5 23.5 26.5ZM20.5 25C19.1193 25 18 26.1193 18 27.5C18 28.8807 19.1193 30 20.5 30H23.5C24.8807 30 26 28.8807 26 27.5C26 26.1193 24.8807 25 23.5 25H20.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 19.5H27.5C26.9477 19.5 26.5 19.9477 26.5 20.5C26.5 21.0523 26.9477 21.5 27.5 21.5H30.5C31.0523 21.5 31.5 21.0523 31.5 20.5C31.5 19.9477 31.0523 19.5 30.5 19.5ZM27.5 18C26.1193 18 25 19.1193 25 20.5C25 21.8807 26.1193 23 27.5 23H30.5C31.8807 23 33 21.8807 33 20.5C33 19.1193 31.8807 18 30.5 18H27.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnConfigurationLight);
export default __webpack_public_path__ + "static/media/btn_configuration_light.deae760c7c7c9a7ff1baef63ebe7f4a8.svg";
export { ForwardRef as ReactComponent };